/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {combineReducers} from 'redux';
import groups from '@ion/applications/src/pages/admin/groups/state';
import adminNotifications from '@ion/applications/src/pages/admin/notifications/state';
import adminRoles from '@ion/applications/src/pages/admin/roles/state';
import crashboxx from '@ion/applications/src/pages/crashBoxx/state';
import devices from '@ion/applications/src/pages/devices/state';
import notificationEvents from '@ion/applications/src/pages/events/notifications/state';
import query from '@ion/applications/src/query/state';
import vision from '../../routes/vision/visionState';
import adminAssets from './admin-assets';
import adminDevices from './admin-devices';
import adminDrivers from './admin-drivers';
import adminGeofences from './admin-geofences';
import adminGroups from './admin-groups';
import adminIOProfiles from './admin-ioprofiles';
import adminMaintenance from './admin-maintenance';
import adminMaintenanceSchedules from './admin-maintenance-schedules';
import adminMaintenanceServices from './admin-maintenance-services';
import adminRoutes from './admin-routes';
import adminSchedules from './admin-schedules';
import adminUsers from './admin-users';
import dashboard from './dashboard';
import errors from './errors';
import exporter from './exporter';
import geofenceEvents from './geofence-events';
import globalGroup from './global-group-chooser';
import groupsFilter from './groups-filter';
import importer from './importer';
import initialization from './initialization';
import issues from './issues';
import login from './login';
import maintenance from './maintenance';
import nav from './nav';
import notifications from './notifications';
import reports from './reports';
import search from './search';
import tracking from './tracking';
import userPrompt from './user-prompt';

/**
 * Defines the root reducer which is a composite of all application specific
 * reducers via combineReducers.
 */
const rootReducer = combineReducers({
  initialization,
  login,
  globalGroup,
  query,
  search,
  errors,
  nav,
  dashboard,
  tracking,
  issues,
  reports,
  crashboxx,
  maintenance,
  notifications,
  devices,
  vision,
  adminAssets,
  adminNotifications,
  adminRoles,
  adminRoutes,
  adminDevices,
  adminGroups,
  adminUsers,
  adminSchedules,
  adminIOProfiles,
  adminDrivers,
  adminGeofences,
  adminMaintenance,
  adminMaintenanceServices,
  adminMaintenanceSchedules,
  userPrompt,
  exporter,
  importer,
  geofenceEvents,
  notificationEvents,
  groupsFilter,
  groups
});
export default rootReducer;
